import { CoverflowCarousel } from '../components/ui/coverflow-carousel';
import { motion } from 'framer-motion';

const works = [
  {
    src: "https://images.unsplash.com/photo-1511818966892-d7d671e672a2?q=80&w=800&h=1067&fit=crop",
    alt: "Loller - Multi-residential project",
    title: "Loller",
    subtitle: "Multi-residential · 2025",
  },
  {
    src: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&h=1067&fit=crop",
    alt: "Southbank Tower - Commercial project",
    title: "Southbank Tower",
    subtitle: "Multi-residential · 2019",
  },
  {
    src: "https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=800&h=1067&fit=crop",
    alt: "Agency Growth Campaign",
    title: "Growth Systems",
    subtitle: "Digital Strategy · 2024",
  },
  {
    src: "https://images.unsplash.com/photo-1551434678-e076c223a692?q=80&w=800&h=1067&fit=crop",
    alt: "Data Intelligence Dashboard",
    title: "Intelligence Platform",
    subtitle: "Data & Analytics · 2024",
  },
  {
    src: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=800&h=1067&fit=crop",
    alt: "E-Commerce Platform",
    title: "Commerce Engine",
    subtitle: "Omnichannel Commerce · 2023",
  },
  {
    src: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?q=80&w=800&h=1067&fit=crop",
    alt: "AI Automation System",
    title: "AI Workflows",
    subtitle: "Aurelix AI · 2025",
  },
  {
    src: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?q=80&w=800&h=1067&fit=crop",
    alt: "Penthouse Vivace - Residential",
    title: "Penthouse Vivace",
    subtitle: "Residential · 2025",
  },
  {
    src: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=800&h=1067&fit=crop",
    alt: "Brand Performance Strategy",
    title: "Brand Performance",
    subtitle: "Creative & CRO · 2023",
  },
];

export default function SelectedWorks() {
  return (
    <>
      <style>{`
        .sw-section {
          background: #000000;
          position: relative;
          padding: clamp(60px, 8vh, 110px) 0;
          overflow-x: hidden;
          overflow-y: visible;
          border-top: 1px solid rgba(255, 255, 255, 0.06);
        }

        .sw-top-bar {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 clamp(20px, 5vw, 80px);
          margin-bottom: clamp(36px, 5vh, 64px);
        }

        .sw-label {
          font-family: 'Bricolage Grotesque', sans-serif;
          font-size: 0.72rem;
          letter-spacing: 0.25em;
          text-transform: uppercase;
          color: #ec2b28;
          font-weight: 700;
        }

        .sw-heading {
          font-family: 'Bricolage Grotesque', sans-serif;
          font-size: clamp(2.4rem, 5.5vw, 4.5rem);
          font-weight: 800;
          color: #fff;
          line-height: 1.08;
          letter-spacing: -0.035em;
          margin: 0;
          text-align: center;
          text-transform: none;
        }

        .sw-heading em {
          font-style: normal;
          color: #ec2b28;
        }

        .sw-meta {
          font-family: 'Bricolage Grotesque', sans-serif;
          font-size: 0.72rem;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          color: #444;
          font-weight: 400;
        }

        .sw-header-row {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
          gap: 14px;
          margin-bottom: clamp(28px, 4vh, 48px);
        }

        .sw-header-left {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;
        }

        .sw-header-line {
          height: 1px;
          background: rgba(255, 255, 255, 0.08);
        }

        .sw-header-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
        }

        .sw-counter {
          display: none;
        }

        .sw-header-right {
          display: none;
        }

        .sw-hint {
          font-family: 'Bricolage Grotesque', sans-serif;
          font-size: 0.78rem;
          color: rgba(255, 255, 255, 0.3);
          letter-spacing: 0.08em;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .sw-hint-line {
          display: inline-block;
          width: 28px;
          height: 1px;
          background: rgba(255, 255, 255, 0.2);
        }

        .sw-carousel-container {
          position: relative;
          width: 100%;
        }

        @media (max-width: 768px) {
          .sw-header-row {
            gap: 16px;
          }
        }
      `}</style>

      <section className="sw-section" id="selected-works">
        {/* Header */}
        <div className="sw-header-row">
          <motion.div
            className="sw-header-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="sw-label">Selected Works</span>
            <h2 className="sw-heading">
              Our work <em>speaks.</em>
            </h2>
            <p className="sw-hint">
              <span className="sw-hint-line" />
              Drag or swipe to explore
            </p>
          </motion.div>

          <motion.span
            className="sw-counter"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            0{works.length}
          </motion.span>

          <motion.div
            className="sw-header-right"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <span className="sw-meta">17 – 25'</span>
            <span className="sw-meta">Projects</span>
          </motion.div>
        </div>

        {/* Coverflow Carousel */}
        <motion.div
          className="sw-carousel-container"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <CoverflowCarousel
            slides={works}
            showCaption={true}
            showNavigation={true}
            showPagination={true}
            cardWidth="clamp(200px, 24vw, 340px)"
            rotate={44}
            depth={0.6}
            perspective={3}
            fade={0.12}
            loop={true}
            label="Selected works carousel"
          />
        </motion.div>
      </section>
    </>
  );
}